import { sliderCurve, inverseCurve } from '../LogSlider'

export const reducers = {
    //property management
    propertyManagementUnitNumber: [
        1,
        {
            setPropertyManagemenSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value)),
            setPropertyManagementInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    propertyManagemenSliderValue: [
        null,
        {
            setPropertyManagemenSliderValue: (_: null, { value }: { value: number }) => value,
            setPropertyManagementInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],
    propertyManagementInputValue: [
        1,
        {
            setPropertyManagemenSliderValue: (_: null, { value }: { value: number }) =>
                Math.round(sliderCurve(value) / 1),
            setPropertyManagementInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    pricingOption: [
        'propertymanagementcloud-standard',
        {
            setPricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
    //crm
    realestateCrmUserNumber: [
        1,
        {
            setRealestateCrmSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value)),
            setRealestateCrmInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    realestateCrmSliderValue: [
        null,
        {
            setRealestateCrmSliderValue: (_: null, { value }: { value: number }) => value,
            setRealestateCrmInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],
    realestateCrmInputValue: [
        1,
        {
            setRealestateCrmSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value) / 1),
            setRealestateCrmInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    crmPricingOption: [
        'real-estate-crm-cloud-standard',
        {
            setCrmPricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
    //marketing
    realestateMarketingUserNumber: [
        1,
        {
            setRealestateMarketingSliderValue: (_: null, { value }: { value: number }) =>
                Math.round(sliderCurve(value)),
            setRealestateMarketingInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    realestateMarketingSliderValue: [
        null,
        {
            setRealestateMarketingSliderValue: (_: null, { value }: { value: number }) => value,
            setRealestateMarketingInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],

    realestateMarketingInputValue: [
        1,
        {
            setRealestateMarketingSliderValue: (_: null, { value }: { value: number }) =>
                Math.round(sliderCurve(value) / 1),
            setRealestateMarketingInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    marketingPricingOption: [
        'real-estate-marketing-cloud-standard',
        {
            setMarketingPricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
    //marketing contacts
    marketingContactsUserNumber: [
        1,
        {
            setMarketingContactsSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value)),
            setMarketingContactsInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    marketingContactsSliderValue: [
        null,
        {
            setMarketingContactsSliderValue: (_: null, { value }: { value: number }) => value,
            setMarketingContactsInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],
    marketingContactsInputValue: [
        1,
        {
            setMarketingContactsSliderValue: (_: null, { value }: { value: number }) =>
                Math.round(sliderCurve(value) / 1),
            setMarketingContactsInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    marketingContactsPricingOption: [
        'marketing-contacts-cloud-standard',
        {
            setMarketingContactsPricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
    //marketing website
    marketingWebsiteUserNumber: [
        1,
        {
            setMarketingWebsiteSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value)),
            setMarketingWebsiteInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    marketingWebsiteSliderValue: [
        null,
        {
            setMarketingWebsiteSliderValue: (_: null, { value }: { value: number }) => value,
            setMarketingWebsiteInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],
    marketingWebsiteInputValue: [
        1,
        {
            setMarketingWebsiteSliderValue: (_: null, { value }: { value: number }) =>
                Math.round(sliderCurve(value) / 1),
            setMarketingWebsiteInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    marketingWebsitePricingOption: [
        'marketing-website-cloud-standard',
        {
            setMarketingWebsitePricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
    //marketing app
    marketingAppUserNumber: [
        1,
        {
            setMarketingAppSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value)),
            setMarketingAppInputValue: (_: null, { value }: { value: number }) => value * 1,
        },
    ],
    marketingAppSliderValue: [
        null,
        {
            setMarketingAppSliderValue: (_: null, { value }: { value: number }) => value,
            setMarketingAppInputValue: (_: null, { value }: { value: number }) => inverseCurve(value * 1),
        },
    ],
    marketingAppInputValue: [
        1,
        {
            setMarketingAppSliderValue: (_: null, { value }: { value: number }) => Math.round(sliderCurve(value) / 1),
            setMarketingAppInputValue: (_: null, { value }: { value: number }) => value,
        },
    ],
    marketingAppPricingOption: [
        'marketing-app-cloud-standard',
        {
            setMarketingAppPricingOption: (_: null, { option }: { option: string }) => option,
        },
    ],
}
